import { Message } from 'element-ui'
export default {
	success(msg){
		Message({
			type: 'success',
			customClass: 'messageIndex',
			message: msg
		})
	},
	error(msg){
		Message({
			type: 'error',
			customClass: 'messageIndex',
			message: msg
		})
	},
	warning(msg){
		Message({
			type: 'warning',
			customClass: 'messageIndex',
			message: msg
		})
	},
	info(msg){
		Message({
			type: 'info',
			customClass: 'messageIndex',
			message: msg
		})
	}
}